
import { Get_Astrology_pages } from "../../api/global/Global"
import {
  FETCH_MASTER_DATA_REQUEST,
  FETCH_MASTER_DATA_SUCCESS,
  FETCH_MASTER_DATA_FAILURE
} from "../types"

export const fetchMasterData = () => async (dispatch, getState) => {

  const { masterdata } = getState();
  const { horoscopePages } = masterdata;

  if (horoscopePages && horoscopePages?.length > 0) {
    // console.log("✅ Horoscope data already fetched. Skipping API call.");
    return;
  }

  dispatch({ type: FETCH_MASTER_DATA_REQUEST });
  try {
    const response = await Get_Astrology_pages();

    if (response?.data?.status == 200) {
      dispatch({
        type: FETCH_MASTER_DATA_SUCCESS,
        payload: response?.data?.data,
      });
    } else {
      dispatch({
        type: FETCH_MASTER_DATA_FAILURE,
        payload: "Failed to fetch master data",
      });
    }
  } catch (error) {
    console.log("error", error);
    dispatch({
      type: FETCH_MASTER_DATA_FAILURE,
      payload: error.message,
    });
  }
};